import React from 'react';
import { Facebook, Instagram, ExternalLink } from 'lucide-react';
const TiktokIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" data-id="element-986">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.7a8.18 8.18 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.13z" data-id="element-987" />
  </svg>;
export function SocialFeed() {
  return <section className="w-full py-10 px-4 bg-white/50" data-id="element-988">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-989">
        <h2 className="text-2xl md:text-3xl font-serif text-[#1A1A1A] mb-2" data-id="element-990">
          Följ oss
        </h2>
        <p className="text-[#1A1A1A]/50 text-sm mb-8 text-center max-w-md" data-id="element-991">
          Håll dig uppdaterad med våra senaste bakverk och nyheter.
        </p>

        <div className="w-full flex flex-col items-center gap-6" data-id="element-992">
          {/* Instagram Feed */}
          <div className="flex flex-col items-center w-full max-w-[420px]" data-id="element-993">
            <div className="flex items-center gap-2 mb-3" data-id="element-994">
              <Instagram className="h-5 w-5 text-[#7C8062]" data-id="element-995" />
              <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-996">Instagram</h3>
            </div>

            <div className="bg-white p-2 rounded-xl shadow-sm border border-[#7C8062]/15 w-full" data-id="element-997">
              <div className="w-full overflow-hidden flex justify-center bg-gray-50 rounded-lg" style={{
              maxHeight: '380px'
            }} data-id="element-998">
                <iframe src="https://www.instagram.com/top.notch.bakery/embed/" width="400" height="480" style={{
                border: 'none',
                overflow: 'hidden'
              }} scrolling="no" frameBorder="0" allowFullScreen={true} title="Top Notch Bakery Instagram" className="max-w-full" data-id="element-999" />
              </div>
            </div>

            <a href="https://www.instagram.com/top.notch.bakery" target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors" data-id="element-1000">
              <span data-id="element-1001">Besök Instagram-profil</span>
              <ExternalLink className="h-3.5 w-3.5" data-id="element-1002" />
            </a>
          </div>

          {/* Facebook & TikTok Links */}
          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-1003">
            <div className="flex flex-col items-center" data-id="element-1004">
              <div className="flex items-center gap-2 mb-3" data-id="element-1005">
                <Facebook className="h-5 w-5 text-[#7C8062]" data-id="element-1006" />
                <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-1007">Facebook</h3>
              </div>
              <a href="https://www.facebook.com/p/Top-Notch-Bakery-100063945724298/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 px-6 py-3 bg-white rounded-xl shadow-sm border border-[#7C8062]/15 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] hover:border-[#7C8062]/30 transition-colors" data-id="element-1008">
                <span data-id="element-1009">Följ oss på Facebook</span>
                <ExternalLink className="h-3.5 w-3.5" data-id="element-1010" />
              </a>
            </div>

            <div className="flex flex-col items-center" data-id="element-1011">
              <div className="flex items-center gap-2 mb-3" data-id="element-1012">
                <TiktokIcon data-id="element-1013" />
                <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-1014">TikTok</h3>
              </div>
              <a href="https://www.tiktok.com/@topnotchbakery" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 px-6 py-3 bg-white rounded-xl shadow-sm border border-[#7C8062]/15 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] hover:border-[#7C8062]/30 transition-colors" data-id="element-1015">
                <span data-id="element-1016">Följ oss på TikTok</span>
                <ExternalLink className="h-3.5 w-3.5" data-id="element-1017" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}